import { FC } from "react";

const CellDisplay: FC<{
    value: string | number | null | undefined,
    errorIf: boolean,
    errorText?: string
}> = ({ value, errorIf, errorText }) => {
    return errorIf
        ? <div style={{ color: 'var(--dcs-error-red)', fontWeight: 'bold' }}>
            {value ?? errorText ?? 'Not Assigned'}
        </div>
        : <>{value}</>;
}

export default CellDisplay;